
import { TablaListadoUsuarios } from "../components";
import { LayoutCrearDoc } from "../../layouts";
import { BuscadorXTermino } from "../../components/buscadores";
import { useNavigate } from "react-router-dom";
import { useListUserXRole } from "../../../hooks/cache";
import { CargandoMedio } from "../../components";



export const ListadoTodosClientes = () => {


    const navigate = useNavigate();
    const { data, isLoading, page, termino, chagePage, chageTermino } = useListUserXRole(['CLIENTE']);
    
    
        
    const handleNavegar = () => {
        navigate(`/super/crearUsuario`);
    }


    return (

        <LayoutCrearDoc titulo='Listado Clientes' funcion={ handleNavegar }>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de clientes..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="usuario" playhol="nombre ciudad movil cedula" />
                <TablaListadoUsuarios data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>
    )
}
